export default class PlaceholderHandler {
    constructor(placeholderUrl) {
        this.vue = window.AppKit.getApp();
        this.placeholderUrl = placeholderUrl;
        this.fetchPlaceholder();
    }

    /**
     * get placeholders
     * @returns {*}
     */
    async getPlaceholders() {
        if  ( ! this.placeholders) {
            await this.fetchPlaceholder();
        }

        return this.placeholders;
    }

    // getPlaceholderUrl() {
    //     const url = (new URL(this.blueprintUrl));
    //     url.searchParams.append('placeholders', true);
    //     url.searchParams.append('bypass-token', this.previewTokens.previewToken);
    //     url.searchParams.append('bypass-time', this.previewTokens.previewTimestamp);
    //
    //     return url.toString();
    // }

    /**
     * Fetch the placeholders
     * @return {Promise<void>}
     */
    async fetchPlaceholder() {
        this.placeholders = await this.vue.$get(this.placeholderUrl, null, null, null, true);
    }
}
